<template>
  <div class="flex-stretch">
    <div class="flex-row gap-sm align-items-center">

      <p style="min-width: 115px; margin: 0">Template</p>

      <div id="email-template-input-container" class="flex-row flex-stretch gap-sm align-items-center">

        <dd-select
          id="email-template-input"
          class="border-radius-xs"
          @input="handleTemplateChange"
          :value="value"
          v-bind="$attrs"
          :searchable="true"
        >
          <a-select-option value="0">Geen</a-select-option>

          <template v-if="showAllTemplates">
            <a-select-opt-group
                v-for="(templates, key) in templatesSortedByCategory"
                :key="key"
                :label="CategoryDisplayEnum[key]"
            >
              <a-select-option
                  v-for="(template, index) in templates"
                  :key="index"
                  :value="template.id"
              >
                {{template.nameInSystem}}
              </a-select-option>
            </a-select-opt-group>
          </template>

          <template v-else>
            <a-select-option
                v-for="(template, index) in templatesByInstanceCategory"
                :key="index"
                :value="template.id"
            >
              {{template.nameInSystem}}
            </a-select-option>
          </template>
        </dd-select>

        <a-tooltip placement="left">
          <template slot="title">
            <span>Toon alle templates</span>
          </template>
          <dd-checkbox id="allTemplatesCheckbox" v-model="showAllTemplates"/>
        </a-tooltip>
      </div>
    </div>

    <dd-dialog-modal
        :visible="dialogData !== undefined"
        title="Template aanpassen"
        description="Weet je zeker dat je dit template wil gebruiken? De reeds ingevoerde tekst zal worden verwijderd."
    >
      <template #buttons>
        <dd-button type="danger" @click="cancelTemplateDialog"> Nee </dd-button>
        <dd-button type="success" @click="acceptTemplate"> Ja </dd-button>
      </template>
    </dd-dialog-modal>

  </div>
</template>

<script>
import CategoryDisplayEnum from "~/enums/CategoryDisplayEnum"
import CategoryByClassEnum from "~/enums/CategoryByClassEnum"
import {mapGetters, mapState} from "vuex";
import templateApi from "~/api/template";

export default {
    name: "TemplateSelect.vue",
    data(){
        return {
          dialogData: undefined,
          showAllTemplates: false,
          value: 0,
        };
    },
    methods:{
      handleTemplateChange(value){
        if (this.value !== value){
          this.dialogData = value;
        }
      },
      cancelTemplateDialog(){
        this.dialogData = undefined;
      },
      async acceptTemplate(){
        this.value = this.dialogData;

        if ( this.value === '0' ){
          this.$emit('input', {id: 0});
          this.dialogData = undefined;
          return;
        }

        const {data: parsedTemplate} = await templateApi.getParsedTemplateByIdAndInstances(
            this.value,
            this.instanceId && [{
              class: this.instanceClass,
              id: this.instanceId.toString()
            }]
        );

        parsedTemplate.content.replaceAll(/class="mceNonEditable"/g, 'contenteditable="false"');

        this.$emit('input', {
          parsedTemplate,
          id: this.value
        });

        this.dialogData = undefined;
      },
    },
    computed: {
      ...mapGetters("email", [
        "templates",
        "firstSelectedEmail"
      ]),
      ...mapState("email", [
        "createEmailCustomerId",
      ]),
      CategoryDisplayEnum(){
        return CategoryDisplayEnum;
      },
      category(){
        return this.firstSelectedEmail?.attachable?.data?.attachable_category?.data?.attachable?.data?.parent_category
            || Number(this.$route.params?.category);
      },
      instanceClass(){
        return this.$route.params?.instanceClass || 'customer';
      },
      instanceId(){
        return this.$route.params?.instanceId
            || this.$route.params?.customerId
            || this.createEmailCustomerId
            || this.firstSelectedEmail.customer_id;
      },
      instanceCategory(){
        return this.category || CategoryByClassEnum[this.instanceClass];
      },
      templatesByInstanceCategory(){
        return this.templates.filter(template => template.category === this.instanceCategory);
      },
      templatesSortedByCategory(){
        const sortedTemplates = {};
        this.templates.forEach(template => {
          if (!sortedTemplates[template.category]) sortedTemplates[template.category] = [];
          sortedTemplates[template.category].push(template);
        })
        return sortedTemplates;
      }
    }
}
</script>

<style lang="scss" scoped>
  @import "~@/_default.scss";
  #email-template-input-container {
    max-width: calc(100% - 115px);
    overflow-x: hidden;
  }
  #email-template-input{
    max-width: calc(100% - #{$spacing-xxl});
    flex: 1;
  }
  #allTemplatesCheckbox{
    width: $spacing-xl;
    display: flex;
    justify-content: center;
  }
</style>

<style lang="scss">
  @import "~@/_default.scss";
  #allTemplatesCheckbox input{
    margin-left: 10px !important;
  }
  .ant-select-selection-selected-value {
    overflow-x: hidden !important;
  }
</style>
